var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf",style:({width: _vm.width + 'px', height: _vm.height + 'px'})},[_c('iframe',{attrs:{"src":_vm.perviewUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"auto"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2665c624","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pdf.vue
// module id = Ktht
// module chunks = 1